module.exports = __webpack_public_path__ + "static/media/HomeGraphic10.e8d93816.jpg";